/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Weights_ValueInputs */

const en_landing_why_weights_value = /** @type {(inputs: Landing_Why_Weights_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Announced, not yet released`)
};

const zh_landing_why_weights_value = /** @type {(inputs: Landing_Why_Weights_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已宣布，尚未发布`)
};

/**
* | output |
* | --- |
* | "Announced, not yet released" |
*
* @param {Landing_Why_Weights_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_weights_value = /** @type {((inputs?: Landing_Why_Weights_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Weights_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_weights_value(inputs)
	return zh_landing_why_weights_value(inputs)
});
export { landing_why_weights_value as "landing.why.weights_value" }